var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    fill: "#FEE4E2",
    rx: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    stroke: "#FEF3F2",
    strokeWidth: 8,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B42318",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.3 21.7h17.4m-12.6 0v-1.2a2.4 2.4 0 0 1 2.4-2.4h3a2.4 2.4 0 0 1 2.4 2.4v1.2m-1.2 4.8v6.6m-5.4-6.6v6.6m-4.8-11.4h15l-.774 13.933A2.4 2.4 0 0 1 32.33 37.9h-8.66a2.4 2.4 0 0 1-2.396-2.267z"
  })));
};
export default SvgTrash;